import React from 'react';
import DiagnosticHeader from "components/DiagnosticHeader";

const Header = ({ handleGoBack, eleve, studentDemo, data }) => (
    <DiagnosticHeader
        onBack={handleGoBack}
        studentDemo={studentDemo}
        matiere={data?.type ?? "Lecture"}
    />
);

export { Header };
